

































































































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Enums/Data
import { WebhookStatuses } from "@/data/enums/webhooks";
import { DataModules } from "@/store/modules/data";

// Types
import { IWebhookEvent } from "@/models/webhooks";
import { ITemplateCategory } from "@/models/templates";
import { AdminRoutes } from "@/data/enums/router";

@Component({
  components: {
    "webhook-events-status-icon": () =>
      import(
        "@/components/app/admin/settings/webhooks/webhookEventStatusIcon.vue"
      )
  }
})
export default class WebhookEventRowItem extends Vue {
  // Props

  @Prop({ default: null })
  public webhookEvent!: IWebhookEvent;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: () => [] })
  public categories!: ITemplateCategory[];

  // Data

  public webhookEditRouteName = AdminRoutes.WEBHOOKS_SETTINGS_WEBHOOK_EDIT;

  // Computed

  public get categoryName() {
    return _.get(
      _.find(this.categories, category =>
        _.some(category.hooks || [], ["id", this.hookId])
      ),
      "name",
      "-"
    );
  }

  public get hookId() {
    return this.webhookEvent.hook_log?.hook_id;
  }

  public get hookName() {
    return _.get(
      _.find(
        _.get(
          _.find(this.categories, category =>
            _.some(category.hooks || [], ["id", this.hookId])
          ),
          "hooks",
          []
        ),
        ["id", this.hookId]
      ),
      "name",
      "-"
    );
  }

  public get showSkeleton() {
    return this.isLoading || _.isNull(this.webhookEvent);
  }

  public get hasFailed() {
    return this.webhookEvent.status === WebhookStatuses.FAILED;
  }

  public get mappedStatus() {
    return this.$store.getters[
      `data/${DataModules.WEBHOOKS_EVENTS}/getEventMappedStatus`
    ](this.webhookEvent.status);
  }
}
